import React from "react";
import { Sparkles } from "lucide-react";
import type { FormData } from "../types";
import { SLIDE_STYLE_OPTIONS, COLOR_SCHEME_OPTIONS } from "../SlideTemplates";
import { getSlideColor } from "../utils";
import BasicInfoSection from "../sections/BasicInfoSection";
import SlideStyleSection from "../sections/SlideStyleSection";
import ColorSchemeSection from "../sections/ColorSchemeSection";
import SlideOptionsSection from "../sections/SlideOptionsSection";
import CustomInstructionsSection from "../sections/CustomInstructionsSection";

interface FormStepProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
  onGenerate: () => void;
  subjects: string[];
  classes: string[];
  isLoading?: boolean;
}

export const FormStep: React.FC<FormStepProps> = ({
  formData,
  onFormChange,
  onGenerate,
  subjects,
  isLoading = false,
}) => {
  const isValid = !!(formData.subject && formData.topic);

  return (
    <div className="p-6">
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <BasicInfoSection
          formData={formData}
          onFormChange={onFormChange}
          subjects={subjects}
        />

        <SlideStyleSection
          formData={formData}
          onFormChange={onFormChange}
          slideStyleOptions={SLIDE_STYLE_OPTIONS}
        />

        <ColorSchemeSection
          formData={formData}
          onFormChange={onFormChange}
          colorSchemeOptions={COLOR_SCHEME_OPTIONS}
        />

        <SlideOptionsSection formData={formData} onFormChange={onFormChange} />

        <CustomInstructionsSection
          formData={formData}
          onFormChange={onFormChange}
        />
      </div>

      <div className="flex justify-end">
        <button
          onClick={onGenerate}
          disabled={!isValid || isLoading}
          className="flex items-center gap-3 px-6 py-3 rounded-xl text-white font-medium transition hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: getSlideColor(formData.colorScheme) }}
        >
          <Sparkles className="w-5 h-5" />
          Gerar Apresentação com IA
        </button>
      </div>
    </div>
  );
};
